export default "__VITE_ASSET__a9df7949__"